import {useEffect, useRef, useState} from "react";
import {SGeneralForms, SLocalTreeSelected, SFuncModal } from "shj-components";
import {isEmpty,} from "lodash-es";
import {addTagType, updateTagTypeOrTag} from "@/services/customerServices";
import {message} from "antd";
import {trimStr} from "@/utils/data.ts";

interface IProps {
  editRef: any,
  tagTypeTree: Record<string, any>,
  record?: Record<string, any>
  selectedType?: Record<string, any>
  reload: () => void
  onClose: () => void
}

export const AddOrEditTagTypeModal = (props: IProps) => {
  const ref = useRef()
  const {editRef, record, selectedType, tagTypeTree} = props;
  const [loading, setLoading] = useState(false)
  const baseFormData = {
    groupTag: 'group',
    source: 'tenant',
    tagType: 'custom'
  }

  useEffect(() => {
    initFn();
  }, [selectedType]);

  useEffect(() => {
    initEditFn();
  }, [record]);

  const initFn = () => {
    if (selectedType && !isEmpty(selectedType)) {
      const newInit = {pid: selectedType.id, weight: selectedType.object.weight + 1};
      ref.current?.onFormRef()?.setFieldsValue(newInit);
    } else {
      ref.current?.onFormRef()?.setFieldsValue({pid: '0', weight: 1})
    }
  }

  const initEditFn = () => {
    if (record) {
      const newData = {...record, ...record.object};
      ref.current?.onFormRef()?.setFieldsValue(newData)
    }
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      ref.current?.onFormRef()?.validateFields()
          .then((values) => {
            setLoading(true)
            const apiFn = values.id ? updateTagTypeOrTag : addTagType;
            apiFn({data: {...values, ...baseFormData}}).then(() => {
              message.success('操作成功');
              props.reload?.()
              resolve();
            }).finally(() => setLoading(false))
          })
          .catch(reject);
    });
  }

  const onReset = () => {
    ref.current?.onFormRef()?.resetFields();
    record ? initEditFn() : initFn();
  }

  if (editRef) {
    editRef.current.onFinish = onFinish
    editRef.current.onReset = onReset
  }

  return  <SFuncModal.Content
      onCancel={props.onClose}
      onOk={onFinish}
      confirmLoading={loading}
  >
    <SGeneralForms
      ref={ref}
      initialValues={{pid: '0', weight: 1}}
      layout={'vertical'}
      configs={[{
        layoutRowStyle: { padding:'0px'},
        formItem: [
          {name: 'id', label: 'id', spanCol: 24, hidden: true},
          {name: 'name', label: '分类名称', required: true, spanCol: 24, comConfig: {
            maxLength: 20,
              showCount: true,
              onChange: (v) => ref.current?.onFormRef().setFieldValue('name', trimStr(v.target.value))
            }},
          {
            name: 'pid',
            label: '上级分类',
            spanCol: 24,
            children: <SLocalTreeSelected disabled treeData={[tagTypeTree]} fieldNames={{label: 'label', value: 'id'}}/>
          },
          {name: 'weight', label: '级别', spanCol: 24, hidden: true},
          {name: 'remark', label: '备注', spanCol: 24, type: 'textarea', comConfig: {
              maxLength: 200,
              showCount: true,
            }},
        ]
      }]}
  />
  </SFuncModal.Content>
}